export enum WorkflowExecutionStatuses {
  Intitiated = 1,
  Pending = 2,
  Executing = 3,
  Finished = 4,
  Failed = 5,
  Aborted = 6,
  Warning = 7
}

export enum WorkflowExecutionTypes {
  Scheduled = 1,
  Manual = 2,
  Invoke = 3,
  Admin = 4,
  ManualGeneric = 5
}

export enum ClientTypes {
  Group = 'Company Group',
  Location = 'Customer',
}


export enum ExecutionStatuses {
  Failed = 0,
  Success = 1,
  Warning = 2
}

/**
 * List of IDs from dbo.WorkflowTask table
 */
export enum WorkflowTaskIDs {
  Sync = 1,
  CloseBusinessDate = 2,
  ValidateData = 3,
  DataExport = 4,
  LoadCard = 6
}

export enum WorkflowTaskNames {
  Sync = 'Sync',
  CloseBusinessDate = 'Close date',
  ValidateData = 'Validate data',
  DataExport = 'Data export',
  LoadCard = 'Load card'
}

/**
 * Codes from dbo.WorkflowTask.Name of the tasks the paid date reopen rules refer to
 */
export enum WorkflowTaskCodes {
  Sync = 'SYNC',
  CloseDate = 'CLOSE_DATE',
  ReopenPaidDate = 'REOPEN_PAID_DATE',
  SimulateLoadCard = 'SIMULATE_LOAD_CARD',
  PaidDateDifferenceReport = 'PAID_DATE_DIFF_RPT'
}

/** The paid date reopen tasks: Reopen Paid Date, Simulate Card Load, Paid Date Difference Report */
export const PaidDateReopenTaskCodes: string[] = [
  WorkflowTaskCodes.ReopenPaidDate,
  WorkflowTaskCodes.SimulateLoadCard,
  WorkflowTaskCodes.PaidDateDifferenceReport
];
